import { ModalControls } from "../../../../customHooks/useModalControl";
import {
  getOffsetFromPage,
  getPageFromOffset,
} from "../../../../helperFunctions";
import {
  MembershipExitApprovalQuery,
  MembershipExitApprovalsResponse,
} from "../../../../redux/features/approvals/approvals.type";
import { SingleMembershipExit } from "../../../../redux/features/membership/membership.type";
import { ApprovalActionDetails } from "../../../../utils/types";
import { TimeText } from "../../../typography/timeText";
import { TableComponent } from "../../table";

export const MemberExitTable = ({
  modalControls,
  setSelectedIds,
  selectedIds,
  approvals,
  setActionDetails,
  setSelectedEntry,
  fetching,
  query,
  setQuery,
}: {
  modalControls: ModalControls;
  selectedIds: number[];
  setSelectedIds: (v: number[]) => void;
  approvals?: MembershipExitApprovalsResponse;
  setActionDetails: (v: ApprovalActionDetails) => void;
  setSelectedEntry: (v: SingleMembershipExit) => void;
  fetching: boolean;
  query: MembershipExitApprovalQuery;
  setQuery: (v: MembershipExitApprovalQuery) => void;
}) => {
  const { handleModalOpen } = modalControls;

  return (
    <TableComponent
      mobileCardView
      headers={["Member", "Date Joined", "Initiated On"]}
      headerActionProps={{
        hasActions: true,
        hasCheckbox: true,
        checked:
          selectedIds.length > 0 &&
          selectedIds.length === approvals?.data?.results?.length,
        onCheck: () => {
          setSelectedIds(approvals?.data?.results?.map((i) => i.id) ?? []);
        },
        onUncheck: () => {
          setSelectedIds([]);
        },
        hasMoreMenu: true,
      }}
      rows={
        approvals?.data?.results?.map((entry, idx) => {
          return {
            id: entry.id,
            onClick: () => {
              if (selectedIds.includes(entry.id)) {
                setSelectedIds(selectedIds.filter((i) => i !== entry.id));
              } else {
                setSelectedIds([...selectedIds, entry.id]);
              }
            },
            items: [
              <>
                {entry?.Member?.User?.FirstName} {entry?.Member?.User?.LastName}
              </>,
              <TimeText timeString={entry?.Member?.DateAdded} showTime />,
              <TimeText timeString={entry?.DateAdded} showTime />,
            ],
            actionProps: {
              hasActions: true,
              hasCheckbox: true,
              checked: selectedIds.includes(entry.id),
              onCheck: () => {},
              onUncheck: () => {},
              hasMoreMenu: true,
              moreOptions: [
                {
                  icon: "profile",
                  text: "View Details",
                  onClick: () => {
                    setSelectedEntry(entry);
                    handleModalOpen("memberDetailsModal");
                  },
                  hidden: false,
                },
                {
                  icon: "verified-icon",
                  text: "Accept",
                  onClick: () => {
                    setActionDetails({
                      type: "single",
                      isApprove: true,
                      singleId: entry.id,
                    });
                    setSelectedEntry(entry);

                    handleModalOpen("confirmationModal");
                  },
                },
                {
                  icon: "close-icon",
                  text: "Decline",
                  onClick: () => {
                    setActionDetails({
                      type: "single",
                      isApprove: false,
                      singleId: entry.id,
                    });
                    setSelectedEntry(entry);

                    handleModalOpen("confirmationModal");
                  },
                },
              ],
            },
          };
        }) ?? []
      }
      stickyLastCol
      isRowClickable={true}
      onRowClick={() => {}}
      isTableEmpty={[0, undefined].includes(approvals?.data?.results?.length)}
      emptyTitle="No Pending Approvals"
      isLoading={fetching}
      isPaginated
      currentPage={getPageFromOffset(query.offset!, query.limit!)}
      totalCount={approvals?.data?.count}
      itemsPerPage={query.limit}
      onPageChange={(page) => {
        setQuery({
          ...query,
          offset: getOffsetFromPage(page, query.limit!),
        });
        setSelectedIds([]);
      }}
    />
  );
};
